import { forwardRef } from 'react'
import { clsx } from 'clsx'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'ghost' | 'danger'
  size?:    'sm' | 'md' | 'lg'
  loading?: boolean
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', size = 'md', loading, children, className, disabled, ...props }, ref) => {
    return (
      <button
        ref={ref}
        disabled={disabled || loading}
        className={clsx(
          'inline-flex items-center justify-center font-bold rounded-full transition-all duration-150',
          'disabled:opacity-50 disabled:cursor-not-allowed active:scale-[0.98]',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]/40 focus-visible:ring-offset-2',
          {
            // Variant
            'bg-[var(--accent)] text-[var(--text-on-accent)] hover:opacity-90': variant === 'primary',
            'border border-[var(--border-subtle)] text-[var(--text-primary)] bg-transparent hover:bg-[var(--surface-muted)]': variant === 'ghost',
            'bg-orange text-white hover:opacity-90': variant === 'danger',
            // Size
            'h-8 px-4 text-xs':  size === 'sm',
            'h-10 px-5 text-sm': size === 'md',
            'h-12 px-7 text-base': size === 'lg',
          },
          className,
        )}
        {...props}
      >
        {loading ? (
          <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
        ) : (
          children
        )}
      </button>
    )
  }
)

Button.displayName = 'Button'
export default Button
